function SvgShoppingBag({ color = "currentColor", width = 20, height = 20, ...props }) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M2.5 5.0013L5 1.66797H15L17.5 5.0013M2.5 5.0013V16.668C2.5 17.11 2.67559 17.5339 2.98816 17.8465C3.30072 18.159 3.72464 18.3346 4.16667 18.3346H15.8333C16.2754 18.3346 16.6993 18.159 17.0118 17.8465C17.3244 17.5339 17.5 17.11 17.5 16.668V5.0013M2.5 5.0013H17.5M13.3333 8.33463C13.3333 9.21869 12.9821 10.0665 12.357 10.6917C11.7319 11.3168 10.8841 11.668 10 11.668C9.11595 11.668 8.2681 11.3168 7.64298 10.6917C7.01786 10.0665 6.66667 9.21869 6.66667 8.33463"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgShoppingBag;
